import { render, staticRenderFns } from "./reviewModal.vue?vue&type=template&id=525b6eff&scoped=true&"
import script from "./reviewModal.vue?vue&type=script&lang=js&"
export * from "./reviewModal.vue?vue&type=script&lang=js&"
import style0 from "./reviewModal.vue?vue&type=style&index=0&id=525b6eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b6eff",
  null
  
)

export default component.exports